// Autogenerated file
export const forwardingOrderChangeBehavioursEnum = {
    Update: "Update",
    Delete: "Delete",
};
export const forwardingOrderChangeBehaviours = [
    { label: "Внести изменения в заявку в Загрузках", value: "Update" },
    { label: "Удалить заявку в Загрузках", value: "Delete" },
];
